import '../styles/blocks.scss'

// Import all block scripts
const acfBlocks = import.meta.webpackContext('../../../blocks/src/acf', { mode: 'eager', regExp: /scripts\/_block\.js$/ })
const coreBlocks = import.meta.webpackContext('../../../blocks/src/core', { mode: 'eager', regExp: /scripts\/_block\.js$/ })
const overrideBlocks = import.meta.webpackContext('../../../blocks/overrides', { mode: 'eager', regExp: /scripts\/_block\.js$/ })
const patterns = import.meta.webpackContext('../../../inc/patterns', { mode: 'eager', regExp: /scripts\/_pattern\.js$/ })

// Execute all imported modules
const initParts = async () => {
  // Execute ACF blocks
  for (const key of acfBlocks.keys()) {
    const module = await acfBlocks(key)
    if (module.default) {
      module.default()
    }
  }

  // Execute core blocks
  for (const key of coreBlocks.keys()) {
    const module = await coreBlocks(key)
    if (module.default) {
      module.default()
    }
  }

  // Execute override blocks
  for (const key of overrideBlocks.keys()) {
    const module = await overrideBlocks(key)
    if (module.default) {
      module.default()
    }
  }

  // Execute patterns
  for (const key of patterns.keys()) {
    const module = await patterns(key)
    if (module.default) {
      module.default()
    }
  }
}

// Execute modules when DOM is ready
if (document.readyState !== 'loading') {
  initParts()
} else {
  document.addEventListener('DOMContentLoaded', initParts)
}
